export const nextTick = (callback: () => void): void => {
  setTimeout(callback, 20);
};
